<!-- 选择用户组 -->
<template>
  <div>
    <Select
      v-model="formItem.userGroupList"
      style="width:55%"
      @on-change="changeSelect"
      multiple
      :disabled="selectModalGroupList.length == 0"
      :placement="placement"
    >
      <Option
        v-for="(item, index) in selectModalGroupList"
        :value="item.id"
        :key="index"
        >{{ item.group_name }}</Option
      >
    </Select>
    <Button @click="(modalValue = true), searchModalList()">{{
      $t("selectGroup")
    }}</Button>
    <Modal
      :title="$t('selfGroup')"
      v-model="modalValue"
      footer-hide
      width="1200"
    >
      <Form :label-width="120" label-position="left" :label-colon="true">
        <Row :gutter="15">
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('roleGroupName')">
              <Input v-model="modalItem.group_name"></Input>
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('roleGroupNameDes')">
              <Input v-model="modalItem.group_text"></Input>
            </FormItem>
          </Col>
          <Col span="4">
            <Button
              @click="(modalPageInfo.pageNo = 1), searchModalList()"
              type="primary"
              >{{ $t("Search") }}</Button
            >
          </Col>
        </Row>
      </Form>
      <Table
        :columns="modalColunms"
        :data="modalData"
        border
        :loading="modalLoading"
        @on-select-cancel="TableSelectCancelRowSelect"
        @on-select-all-cancel="cancelAllSelect"
        @on-select-all="selsetAllSelect"
        @on-select="peoOnSelectRowSelect"
      >
        <template slot="distribution" slot-scope="{ row, index }">
          <div
            style="
              display: flex;
              justify-content: center;
              align-items: flex-start;
            "
          >
            <div style="margin-right: 10px;">
              <!-- 分配 -->
              <Button @click="distributionEmp(row, index)" type="primary">{{
                $t("Assign")
              }}</Button>
            </div>
            <div style="margin-right: 10px;">
              <Button @click="exportModal(row, index)" type="primary">{{
                $t("PB_Export")
              }}</Button>
            </div>
            <div style="margin-right: 10px;">
              <!-- <Upload
                action="/api/resource/upload"
                :before-upload="onExcelInport"
              >
                <Button type="primary">
                  导入
                </Button>
              </Upload> -->
              <Button type="primary" @click="openModal(row, index)">
                {{ $t("import") }}
              </Button>
            </div>
          </div>
        </template>
        <template slot="action" slot-scope="{ row, index }">
          <Button @click="editModalRow(row)" type="primary">
            {{ $t("Edit") }}</Button
          >
          <Button @click="delModalRow(row)" type="primary">{{
            $t("Delete")
          }}</Button>
        </template>
      </Table>
      <div
        style="display: flex;justify-content: space-between;margin-top: 15px"
      >
        <div>
          <Page
            :current="modalPageInfo.pageNo"
            :total="modalPageInfo.total"
            @on-change="changeModalPage"
          ></Page>
        </div>
        <div>
          <Button @click="addModalItem" type="primary">{{ $t("Add") }}</Button>
          <Button
            @click="confirmSelect"
            type="primary"
            :disabled="modalSelectList.length == 0"
            >{{ $t("Confirm") }}</Button
          >
        </div>
      </div>
    </Modal>
    <Modal
      :title="$t('Emp_Ach_mess27')"
      v-model="warningModalValue"
      footer-hide
      width="1200"
    >
      <span style="font-size: 18px;color: red;">{{ $t("importWarning") }}</span>
      <Table :columns="modalEmpColunms" :data="importData" border height="620">
      </Table>
      <div
        style="display: flex;
    flex-direction: row-reverse;margin-top: 20px;"
      >
        <div>
          <Button @click="warningModalValue = false">{{ $t("Cancel") }}</Button>
        </div>
        <div>
          <Button @click="onExcelInportConfirm">{{ $t("Confirm") }}</Button>
        </div>
        <div>
          <Upload action="/api/resource/upload" :before-upload="onExcelInport">
            <Button type="primary">
              {{ $t("import") }}
            </Button>
          </Upload>
        </div>
      </div>
    </Modal>
    <Modal
      :title="modalAddStatus == '1' ? $t('Add') : $t('Edit')"
      v-model="modalAddValue"
      footer-hide
      width="600"
    >
      <Form
        :label-width="120"
        label-position="left"
        :label-colon="true"
        :model="modalAddItem"
        ref="modalAddFormRef"
        :rules="rulesAdd"
      >
        <Col :xs="24" :sm="24" :md="12" :lg="24">
          <FormItem :label="$t('roleGroupName')" prop="group_name">
            <Input v-model="modalAddItem.group_name"></Input>
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="24">
          <FormItem :label="$t('roleGroupNameDes')">
            <Input v-model="modalAddItem.group_text"></Input>
          </FormItem>
        </Col>
      </Form>
      <div style="display: flex;justify-content:center;margin-top: 15px">
        <Button @click="modalAddValue = false">{{ $t("Cancel") }}</Button>
        <Button @click="saveAddModal" style="margin-left: 10px;">{{
          $t("Confirm")
        }}</Button>
      </div>
    </Modal>
    <!-- 废弃保留 -->
    <Modal
      :title="$t('empFen')"
      v-model="modalEmpValue"
      footer-hide
      width="1200"
    >
      <!-- <Form :label-width="120" label-position="left" :label-colon="true">
          <Row :gutter="15">
            <Col :xs="24" :sm="24" :md="12" :lg="6">
              <FormItem label="员工姓名">
                <Input v-model="modalEmpItem.userName"></Input>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="12" :lg="6">
              <FormItem label="员工工号">
                <Input v-model="modalEmpItem.empCode"></Input>
              </FormItem>
            </Col>
            <Col span="4">
              <Button
                @click="(modalPageEmpInfo.pageNo = 1), searchEmpModalList()"
                type="primary"
                >检索</Button
              >
            </Col>
          </Row>
        </Form> -->
      <Table
        :columns="modalEmpColunms"
        :data="modalEmpData"
        border
        :loading="modalLoading"
        @on-select-cancel="TableSelectCancelRow"
        @on-select-all-cancel="cancelAll"
        @on-select-all="selsetAll"
        @on-select="peoOnSelectRow"
      >
      </Table>
      <div
        style="display: flex;justify-content: space-between;align-items: center;margin-top: 15px"
      >
        <div>
          <Page
            :current="modalPageEmpInfo.pageNo"
            :total="modalPageEmpInfo.total"
            @on-change="changeModalEmpPage"
          ></Page>
        </div>
        <div
          style="
              display: flex;
              justify-content: space-between;
              align-items: flex-start;
            "
        >
          <Button @click="addModalEmpItem" type="primary" style="margin:10px">{{
            $t("addEmp")
          }}</Button>
          <Button
            style="margin:10px"
            @click="delModalEmpList"
            type="primary"
            :disabled="selectEmpList.length == 0"
            >{{ $t("Delete") }}</Button
          >
        </div>
      </div>
    </Modal>
    <Modal
      :title="$t('errorMessage')"
      v-model="errorModalValue"
      width="1000"
      @on-ok="errorModalValue = false"
    >
      <Table
        :columns="errorColumns"
        :data="errorData"
        border
        v-if="refreshErrorTable"
      ></Table>
    </Modal>
    <SelectPerson
      ref="peoModal"
      @onSelectList="onSelectList"
      @peoSave="peoSave"
    />
  </div>
</template>

<script>
import axios from "axios";
import DateUtil from "../../../../util/DateUtil";
import SelectPerson from "./SelectPerson";
export default {
  props: {},
  components: { SelectPerson },
  data() {
    return {
      date: new DateUtil(),
      formItem: {},
      refreshErrorTable: true,
      //   对话框
      modalValue: false,
      // 新增对话框
      modalAddValue: false,
      // 人员分配
      modalEmpValue: false,
      // 人员新增对话框
      modalAddEmpValue: false,
      // 错误信息
      errorModalValue: false,
      importErrorStatus: "1",
      // 检索分配分页备用
      rowId: "",
      rowIndex: "",
      // 新增对话框 1新增2 保存
      modalAddStatus: "1",
      // 分配->表格多选
      selectEmpList: [],
      //   被选择list
      modalSelectList: [],
      // 被选择的用户组
      selectModalGroupList: [],
      //   新增人员被选择人员list
      selectModalEmpList: [],
      // 导入的数据
      importData: [],
      warningModalValue: false,
      modalPageInfo: {
        pageNo: 1,
        pageSize: 10,
        total: 0
      },
      modalLoading: false,
      modalItem: {
        group_name: "",
        group_text: ""
      },
      modalAddItem: {
        group_name: "",
        group_text: "",
        id: ""
      },
      modalEmpItem: {
        empCode: "",
        userName: ""
      },
      modalPageEmpInfo: {
        pageNo: 1,
        pageSize: 10,
        total: 0
      },
      prevent: false,
      // 用户组的list
      modalData: [],
      // 错误信息
      errorData: [],
      //分配list
      modalEmpData: [],
      selectList: [],
      placement:"bottom-start"
    };
  },
  computed: {
    lang() {
      return this.$store.getters.selectLangeData;
    },
    rulesAdd() {
      return {
        group_name: [
          {
            required: true,
            message: this.$t("PleaseFill") + this.$t("roleGroupName")
          }
        ]
      };
    },
    modalColunms() {
      return [
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: this.$t("roleGroupName"),
          key: "group_name",
          minWidth: 120,
          align: "center"
        },
        {
          title: this.$t("roleGroupNameDes"),
          key: "group_text",
          minWidth: 120,
          align: "center"
        },
        {
          title: this.$t("Assign"),
          slot: "distribution",
          minWidth: 240,
          align: "center"
        },
        {
          title: this.$t("Action"),
          slot: "action",
          minWidth: 120,
          align: "center"
        }
      ];
    },
    modalEmpColunms() {
      return [
        // {
        //   type: "selection",
        //   width: 60,
        //   align: "center"
        // },
        {
          title: this.$t("Employee_Code"),
          key: "empCode",
          Width: 240,
          align: "center"
        },
        {
          title: this.$t("Name"),
          key: this.lang == "zh" ? "userName" : "userEName",
          Width: 240,
          align: "center"
        }
      ];
    },
    modalEmpColunmsExport() {
      return [
        {
          title: this.$t("Employee_Code"),
          key: "empCode",
          minWidth: 120,
          align: "center"
        },
        {
          title: this.$t("Name"),
          key: "userName",
          minWidth: 120,
          align: "center"
        }
      ];
    },
    errorColumns() {
      if (this.importErrorStatus == "1") {
        return [
          {
            type: "index",
            width: 60,
            align: "center"
          },
          {
            title: this.$t("Employee_Code"),
            key: "empCode",
            minWidth: 120,
            align: "center"
          },
          {
            title: this.$t("Name"),
            key: this.lang == "zh" ? "userName" : "userEName",
            minWidth: 120,
            align: "center"
          },
          {
            title: this.$t("errorMessage"),
            key: "errMsg",
            minWidth: 200,
            align: "center"
          }
        ];
      } else {
        return [
          {
            type: "index",
            width: 60,
            align: "center"
          },
          {
            title: this.$t("errorMessage"),
            key: "errMsg",
            minWidth: 200,
            align: "center"
          }
        ];
      }
    }
  },
  created() {
    console.log(this.$t("confirmAdd"));
  },
  methods: {
    openModal(row, index) {
      this.rowId = row.id;
      this.rowIndex = this.index;
      this.warningModalValue = true;
    },
    // 选择一个
    peoOnSelectRowSelect(selection, row) {
      if (!this.modalSelectList.includes(row.serialnumber)) {
        this.modalSelectList.push(row);
      }
    },
    // 取消一个
    TableSelectCancelRowSelect(selection, row) {
      this.modalSelectList.forEach((el, index) => {
        if (el.serialnumber == row.serialnumber) {
          this.modalSelectList.splice(index, 1);
        }
      });
    },
    // 全选
    selsetAllSelect(selection) {
      this.modalData.forEach(el => {
        this.modalSelectList.push(el);
      });
      let map = new Map();
      for (let item of this.modalSelectList) {
        map.set(item.serialnumber, item);
      }
      this.modalSelectList = [...map.values()];
    },
    // 取消全选
    cancelAllSelect(selection) {
      this.modalData.forEach(row => {
        this.modalSelectList.forEach((el, index) => {
          if (el.serialnumber == row.serialnumber) {
            this.modalSelectList.splice(index, 1);
          }
        });
      });
    },
    // 确认选择的用户组
    changeSelect() {
      this.$emit("confirmSelectGroup", this.formItem.userGroupList);
    },
    confirmSelect() {
      this.$Modal.confirm({
        title: this.$t("confirmSelect"),
        onOk: () => {
          this.selectModalGroupList = JSON.parse(
            JSON.stringify(this.modalSelectList)
          );
          this.formItem.userGroupList = [];
          this.selectModalGroupList.forEach(item => {
            this.formItem.userGroupList.push(item.id);
          });
          this.$emit("confirmSelectGroup", this.formItem.userGroupList);
          this.modalValue = false;
        }
      });
    },

    // 导入
    onExcelInport(file) {
      this.$importExcelActiveGroup(file, this.modalEmpColunms, data => {
        let errorMessage = [];
        data.forEach((element, index) => {
          if (!element.userName) {
            errorMessage.push({
              errMsg: "第" + (index + 2) + "行数据缺少姓名"
            });
          }
          if (!element.empCode) {
            errorMessage.push({
              errMsg: "第" + (index + 2) + "行数据缺少员工号"
            });
          }
        });
        if (errorMessage.length > 0) {
          this.importErrorStatus = "2";
          this.errorModalValue = true;
          this.errorData = errorMessage;
          this.refreshErrorTable = false;
          this.$nextTick(() => {
            this.refreshErrorTable = true;
          });
        } else {
          this.importData = data;
        }
      });
      return false;
    },
    // 导入后确认
    onExcelInportConfirm() {
      this.$Spin.show({
        render: h => {
          return h("div", [
            h("Icon", {
              class: "demo-spin-icon-load",
              props: {
                type: "ios-loading",
                size: 18
              }
            }),
            h("div", this.$t("loadingZ"))
          ]);
        }
      });
      this.axios
        .post("customUserGroupSet/excelReportSelectedGroupUserCheck", {
          userList: this.importData,
          id: this.rowId
        })
        .then(res => {
          if (res == "ok") {
            this.$Message.success(this.$t("addSuccess"));
            this.importData = [];
            this.warningModalValue = false;
            // this.modalPageEmpInfo.pageNo = 1;
            // this.searchEmpModalList();
          } else {
            this.importErrorStatus = "1";
            this.refreshErrorTable = false;
            this.$nextTick(() => {
              this.refreshErrorTable = true;
            });
            this.errorModalValue = true;
            this.errorData = res;
          }
          this.$Spin.hide();
        });
    },
    // 导出
    exportModal(row, index) {
      this.modalLoading = true;
      axios
        .post("customUserGroupSet/searchSelectedGroupUser", {
          pageNo: 1,
          pageSize: 99999,
          id: row.id
        })
        .then(res => {
          if (res) {
            res.data;
            let nowDate = this.date.dateVal(new Date(), "YYYY-MM-DD HH-mm-ss");
            nowDate = nowDate.replace("-", "");
            nowDate = nowDate.replace("-", "");
            nowDate = nowDate.replace(" ", "");
            nowDate = nowDate.replace("-", "");
            nowDate = nowDate.replace("-", "");
            console.log(this.modalEmpColunmsExport);
            //   列，导出的文件名称，数据，去掉操作列,[]删除的列 可选key和slot 例子["empname","action"](默认删除没有key的并且没有slot的)
            this.$exportExcelActiveGroup(
              this.modalEmpColunmsExport,
              this.modalData[index].group_name + "的分配人员表" + nowDate,
              res.data,
              []
            );
            this.modalLoading = false;
          }
        });
      //   列，导出的文件名称，数据，去掉操作列,[]删除的列 可选key和slot 例子["empname","action"](默认删除没有key的并且没有slot的)
      // let nowDate = this.date.dateVal(new Date(), "YYYY-MM-DD");
      // nowDate = nowDate.replace("-", "");
      // nowDate = nowDate.replace("-", "");

      // this.$exportExcelActive(
      //   this.modalEmpColunmsExport,
      //   this.modalData[this.rowIndex].group_name + "的分配人员表" + nowDate,
      //   [],
      //   []
      // );
    },
    // 新增选择人员
    onSelectList(selectList) {
      this.selectModalEmpList = JSON.parse(JSON.stringify(selectList));
      this.$Modal.confirm({
        title: this.$t("confirmEdit"),
        onOk: () => {
          axios
            .post("customUserGroupSet/addSelectedGroupUser", {
              id: this.rowId,
              userList: selectList
            })
            .then(res => {
              if (res) {
                this.$Message.success(this.$t("editSuccess"));
                this.$refs.peoModal.modal = false;
                this.$refs.peoModal.selectList = [];
                // this.searchEmpModalList();
              }
            });
        }
      });
    },
    peoSave(json) {},
    // 多选删除分配人员
    delModalEmpList() {
      this.$Modal.confirm({
        title: this.$("confirmDelete"),
        onOk: () => {
          axios
            .post(
              "customUserGroupSet/deleteSelectedGroupUser",
              this.selectEmpList
            )
            .then(res => {
              if (res) {
                this.$Message.success(this.$("deleteSuccess"));
                this.selectEmpList = [];
                this.modalPageEmpInfo.pageNo = 1;
                this.searchEmpModalList();
              }
            });
        }
      });
    },
    // 选择一个
    peoOnSelectRow(selection, row) {
      if (!this.selectEmpList.includes(row.serialnumber)) {
        this.selectEmpList.push(row);
      }
    },
    // 取消一个
    TableSelectCancelRow(selection, row) {
      this.selectEmpList.forEach((el, index) => {
        if (el.serialnumber == row.serialnumber) {
          this.selectEmpList.splice(index, 1);
        }
      });
    },
    // 全选
    selsetAll(selection) {
      this.modalEmpData.forEach(el => {
        this.selectEmpList.push(el);
      });
      let map = new Map();
      for (let item of this.selectEmpList) {
        map.set(item.serialnumber, item);
      }
      this.selectEmpList = [...map.values()];
    },
    // 取消全选
    cancelAll(selection) {
      this.modalEmpData.forEach(row => {
        this.selectEmpList.forEach((el, index) => {
          if (el.serialnumber == row.serialnumber) {
            this.selectEmpList.splice(index, 1);
          }
        });
      });
    },
    // 分配人员分页
    changeModalEmpPage(val) {
      this.modalPageEmpInfo.pageNo = val;
      this.searchEmpModalList();
    },
    // 检索分配人员的list
    searchEmpModalList() {
      // this.modalLoading = true;
      axios
        .post("customUserGroupSet/searchSelectedGroupUser", {
          ...this.modalPageEmpInfo,
          id: this.rowId
        })
        .then(res => {
          if (res) {
            this.modalEmpData = res.data;
            this.$refs.peoModal.selectList = this.modalEmpData;
            // 给表格重新选中
            // this.selectEmpList.forEach(item => {
            //   this.modalEmpData.map(el => {
            //     if (item.serialnumber == el.serialnumber) {
            //       el._checked = true;
            //       return;
            //     }
            //   });
            // });
            // this.modalPageEmpInfo.total = Number(res.pageInfo.total);
            // this.modalLoading = false;
          }
        });
    },
    // 检索对话框的list
    searchModalList() {
      this.modalSelectList = [];
      this.modalLoading = true;
      let obj = {
        ...this.modalItem,
        ...this.modalPageInfo,
        serialnumber: JSON.parse(sessionStorage.getItem("userInfo"))
          .serialnumber
      };
      axios.post("customUserGroupSet/searchUserGroupCustom", obj).then(res => {
        if (res) {
          this.modalData = res.data;
          this.modalPageInfo.total = Number(res.pageInfo.total);
        }
        this.modalLoading = false;
        console.log(this.modalLoading);
      });
    },
    changeModalPage(val) {
      this.modalPageInfo.pageNo = val;
      this.searchModalList();
    },
    //新增
    addModalItem() {
      this.modalAddItem = {
        group_name: "",
        group_text: ""
      };
      this.modalAddValue = true;
      this.modalAddStatus = "1";
    },
    // 分配人员
    async distributionEmp(row, index) {
      this.rowId = row.id;
      this.rowIndex = index;
      this.modalPageEmpInfo.pageNo = 1;
      this.modalPageEmpInfo.pageSize = 99999;
      await this.searchEmpModalList();
      // 检索出数据放入追加人员页面
      this.addModalEmpItem();
    },
    // 新增分配人员
    addModalEmpItem() {
      this.$refs.peoModal.id = this.rowId;
      this.$refs.peoModal.modal = true;
      this.$refs.peoModal.getData();
    },
    // 编辑
    editModalRow(row) {
      this.modalAddItem = JSON.parse(JSON.stringify(row));
      this.modalAddValue = true;
      this.modalAddStatus = "2";
    },
    // 删除
    delModalRow(row) {
      this.$Modal.confirm({
        title: this.$t("confirmDelete"),
        onOk: () => {
          axios
            .post("customUserGroupSet/delUserGroupCustom", { id: row.id })
            .then(res => {
              if (res) {
                this.$Message.success(this.$t("deleteSuccess"));
                this.pageInfo.pageNo = 1;
                this.searchModalList();
              }
            });
        }
      });
    },
    saveAddModal() {
      this.$refs["modalAddFormRef"].validate(vavid => {
        if (vavid) {
          this.$Modal.confirm({
            title:
              this.modalAddStatus == "1"
                ? this.$t("confirmAdd")
                : this.$t("confirmEdit"),
            onOk: () => {
              axios
                .post("customUserGroupSet/saveUserGroupCustom", {
                  ...this.modalAddItem,
                  serialnumber: JSON.parse(sessionStorage.getItem("userInfo"))
                    .serialnumber
                })
                .then(res => {
                  if (res) {
                    this.$Message.success(this.$t("savedSuccessfully"));
                  } else {
                    this.$Message.success(this.$t("saveFilure"));
                  }
                  this.modalAddValue = false;
                  this.searchModalList();
                });
            }
          });
        } else {
          this.$Message.error(this.$t("pleaseFillAll"));
        }
      });
    }
  }
};
</script>

<style lang="less">
.ivu-select-multiple .ivu-select-item {
  padding-left: 40px !important;
}
.ivu-select-multiple .ivu-select-item::after {
  width: 22px !important;
  height: 22px;
  border: 1px solid #cccccc !important;
  border-radius: 3px !important;
  display: inline-block !important;
  font-family: "Ionicons" !important;
  speak: none !important;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  text-rendering: optimizeLegibility;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  vertical-align: -0.125em;
  text-align: center;
  font-size: 22px;
  content: "";
  color: rgba(69, 152, 70, 0.9);
  position: absolute !important;
  top: 4px !important;
  left: 4px !important;
}
.ivu-select-multiple .ivu-select-item-selected:after {
  width: 22px !important;
  height: 22px;
  border: 1px solid #cccccc !important;
  border-radius: 3px !important;
  display: inline-block !important;
  font-family: "Ionicons" !important;
  speak: none !important;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  text-rendering: optimizeLegibility;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  vertical-align: -0.125em;
  text-align: center;
  font-size: 22px;
  content: "\F171";
  color: #fff;
  background: rgba(69, 152, 70, 0.9);
  position: absolute !important;
  top: 4px !important;
  left: 4px !important;
}
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
</style>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/components/UserGroupList.vue